import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { ReactComponent as ArrowRight } from "../../images/ArrowRight.svg";
import { aggreements } from "../../utils/utils";
import { useHistory } from "react-router-dom";
import { Form } from "react-bootstrap";
import { addRoute } from "../../redux/features/candidate/candidateAuthSlice";
import { useDispatch } from "react-redux";

const Aggrement = () => {
  const [checked, setChecked] = useState(false);
  let history = useHistory();
  const dispatch = useDispatch();

  const handleChange = () => {
    setChecked(!checked);
  };

  const handleProceed = () => {
    const path = "/Exam";
    if (checked) {
      dispatch(addRoute(path));
      history.push(path);
    }
  };
  return (
    <div className="instruction-container bg-white">
      <div className="title border-bottom p-3 ">
        <h6 className="fw-bold text-primary mb-0">Agreement</h6>
      </div>
      <div className="px-4 py-4 border-bottom">
        <h6 className="text-secondary mb-4">
          By using proctorme, you agree to the following.
        </h6>
        <div className="d-flex flex-column">
          {aggreements.map((text, i) => (
            <div
              key={`${text + i}agree`}
              className="d-flex flex-row mb-3 align-items-center"
            >
              <ArrowRight />
              <p className="ms-3 mb-0 pt-1 text-info">{text}</p>
            </div>
          ))}
        </div>

        <div className="d-flex flex-column mt-3">
          <Form.Check
            variant="darkblue"
            type="checkbox"
            className=""
            checked={checked}
            onChange={handleChange}
            label="Yes, i agree"
          />
        </div>
      </div>

      <div className="py-4">
        <div className="d-flex justify-content-end px-4">
          <Button variant="outline-danger" className="me-2">
            Cancel
          </Button>
          <Button
            variant="success"
            className="text-white"
            onClick={handleProceed}
            disabled={!checked}
          >
            Proceed
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Aggrement;
